import React from 'react';
import SvgEdit = require('react-icons/lib/md/edit');
import SvgDelete = require('react-icons/lib/md/delete');
import SvgDone = require('react-icons/lib/md/done');
import SvgClear = require('react-icons/lib/md/clear');
import Form from "core/form/form";
import {IDomainObject, FormProps, ClosedContentProps} from "core/form/formUtils";
import {action} from "mobx";
import {observer} from "mobx-react";

import 'core/components/blockComp/activeItem.less';
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import styled from "styled-components";


interface ActiveItemProps<D extends DomainAncestor, R extends DomainAncestor> extends FormProps<D, R> {
  index?: number;
  openContent?: any;
  closedContent?: React.ReactElement<ClosedContentProps<D>>;
  onDelete?: Function;
  closedStyle?: any;
  openButtons?: React.ReactNode;
  openClassName?: string;
  disableEditing?: boolean;
}

// dataObject,
//   openContent,
//   closedContent,
//   onDelete,
//   formName,
//   closedStyle,
//   validate, rootObject, entity, entities, setDataAction, index, containerObject,

const OpenButtonLineDiv = styled.div`
  display: flex;
  align-items: flex-end;
`;

@observer
export default class ActiveItem extends React.Component<ActiveItemProps<DomainAncestor, DomainAncestor>, undefined> {


  @action onClick = (evt) => {
    let {dataObject, rootObject, formName} = this.props;

    let form = dataObject.getForm(formName);

    if (!form.$open) {
      form.$open = true;
      form.$pristineObject = dataObject.cloneShallow();
      //rootObject.$dirty = true;
      console.log('onClick form.$pristineObject %O,  dataObject %O', form.$pristineObject, dataObject);
    }
  };

  @action onCommit = (evt) => {
    evt.stopPropagation();
    let {dataObject, rootObject, validate, formName} = this.props;

    let res = validate(dataObject);
    if (!res) return;

    let form = dataObject.getForm(formName);
    form.$open = false;
    dataObject.$added = undefined;
    form.$pristineObject = undefined;
    console.log('onCommit %O', dataObject);
  };

  @action onRollback = (evt) => {
    evt.stopPropagation();
    let {dataObject, rootObject, formName} = this.props;

    let form = dataObject.getForm(formName);
    form.$open = false;

    if (dataObject.$added) {
      this.props.onDelete(evt);
    } else {
      dataObject.shallowOwnCopyProperties(form.$pristineObject);
      form.updateAllFieldsPropValue(dataObject);

    }

    console.log('onRollback form.$pristineObject %O, dataObject %O', form.$pristineObject, dataObject);
    form.$pristineObject = undefined;

  };

  @action onDelete = (evt) => {
    let {onDelete, rootObject} = this.props;
    rootObject.$dirty = true;
    onDelete(evt);
  };


  render() {

    let {
      dataObject,
      openContent,
      closedContent,
      onDelete,
      disableEditing,
      formName,
      closedStyle,
      openButtons,
      openClassName,
      validate, rootObject, entity, entities, index,
      ...other
      } = this.props;


    let form = dataObject.getForm(formName);

    return (form.$open) ? (
      <div className={(openClassName) ? openClassName : "active-item--open"}>
        {openContent}

        <OpenButtonLineDiv>
          <SvgDone className="active-item--check  zz-mr-15" size={24} onClick={this.onCommit}/>
          <SvgClear className="active-item--check" size={24} onClick={this.onRollback}/>

          {(openButtons) ? openButtons : null}
        </OpenButtonLineDiv>

      </div>
    ) : (
      <div className='active-item--closed' style={closedStyle}>
        {closedContent}
        <div className="active-item--action-group">
          { !disableEditing && <SvgEdit className="active-item--action" onClick={this.onClick}/>}
          { (onDelete && !disableEditing) ?  (<SvgDelete className="active-item--action zz-ml-5"  onClick={this.onDelete}/>) : null}
        </div>
      </div>
    );

  }


}



// WEBPACK FOOTER //
// ./src/core/components/blockComp/activeItem.tsx